window.jQuery = require('jquery');
window.$ = require('jquery');
window.Cookie = require('js-cookie');
require('./picturefill.js');
var LazyLoad = require('vanilla-lazyload');
var menuJS = require('./menu.js');
var flickitySlider = require('./flickity.js');
var lightbox = require('./lightbox.js');
var sliderFade = require('./fadeSlider.js');
var playGames = require('./games.js');
var showreel = require('./showreel.js');
var mapsQuickspin = require('./maps.js');
var locationcheck = require('./locationcheck.js');
var registerForm = require('./registerForm.js');
var countdown = require('./countdown.js');
var gameReleaseSlider = require('./gameReleaseSlider.js');
var generalSlider = require('./generalSlider.js');
var gameLightBox = require('./gameLightBox.js');
var downloadFile = require('./downloadFile.js');


(function($) {

    const lazyLoad = new LazyLoad({
        elements_selector: ".lazy"
    });

    $(window).scroll(function () {
        var scrollTop = $(this).scrollTop();

        if (scrollTop >= 20) {
            $(".top-navigation").addClass("fade");
        } else {
            $(".top-navigation").removeClass("fade");
        }
    });

    // Smoothscroll on link-clicks.
    $('.js-anchor').click(function() {
        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top - 150
        }, 500);
        return false;
    });

    // News post "Load More"
    var loadMore = $('.load-more');
    var newsPosts = $('.list-cards_card');
    var visibleNews = 9;

        function newsPostsLoad () {
            newsPosts.each(function( i, card ) {
                if ( i <= visibleNews ) {
                    $(this).addClass('list-cards_card--show');
                }
            });
        };
        newsPostsLoad();

        loadMore.on('click', function() {
            visibleNews = visibleNews + 10;

            if ( visibleNews >= newsPosts.length ) {
                loadMore.hide();
            }

            newsPostsLoad();
        });

})(jQuery);
